import { Category } from "./category";
import { JsonProperty } from "../requests/jsonparser";
import { Podcast } from "./podcast";

export class PodcastCategory extends Category {

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'string' })
    slug: string;

    @JsonProperty({ type: 'number' })
    order: number;

    @JsonProperty({ type: 'string?' })
    image_url?: string;

    @JsonProperty({ type: 'Podcast', clazz: Podcast })
    sets: Podcast[];
}


// WEBPACK FOOTER //
// ./src/api/src/models/podcast_category.ts